module.exports = __webpack_public_path__ + "static/media/emilyz.00401056.jpg";